import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import './ConfigCommon.scss';
import { Input } from 'reactstrap';

import { setConfigCommon } from '../../actions';

import {  
  Tooltip,
  validateNumber,
  HeaderSection,
  Card,
} from '../../helpers';

class ConfigCommon extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'maximumParkingFeePerDayActive': 'ENABLE',
      'maximumParkingFeePerDay': '',
      'exitPeriodAfterPayment': '',      
      'isCanSave': false,
    };
  }

  componentDidMount() {
    this.dataFillInput();
  }

  dataFillInput = () => {
    const { configCommon } = this.props;
    
    if (configCommon) {
      this.setState({
        'maximumParkingFeePerDayActive': configCommon.maximumParkingFeePerDayActive,
        'maximumParkingFeePerDay': configCommon.maximumParkingFeePerDay ? configCommon.maximumParkingFeePerDay.toString() : '',
        'exitPeriodAfterPayment': configCommon.exitPeriodAfterPayment ? configCommon.exitPeriodAfterPayment.toString() : '',
      });
    }
  }
 
  handleIsCanSave = () => {
    const { maximumParkingFeePerDay, exitPeriodAfterPayment, maximumParkingFeePerDayActive } = this.state;
    if (maximumParkingFeePerDay !== '' && exitPeriodAfterPayment !== ''){ 
      this.props.dispatch(setConfigCommon({ 
        'maximumParkingFeePerDayActive' : maximumParkingFeePerDayActive,
        'maximumParkingFeePerDay' : maximumParkingFeePerDay !== '' ? parseInt(maximumParkingFeePerDay) : 0,
        'exitPeriodAfterPayment' : exitPeriodAfterPayment !== '' ? parseInt(exitPeriodAfterPayment) : 0,
        'isCanSave' : true, 
      }));
    } else {
      this.props.dispatch(setConfigCommon({ 
        'maximumParkingFeePerDayActive' : maximumParkingFeePerDayActive,
        'maximumParkingFeePerDay' : maximumParkingFeePerDay !== '' ? parseInt(maximumParkingFeePerDay) : 0,
        'exitPeriodAfterPayment' : exitPeriodAfterPayment !== '' ? parseInt(exitPeriodAfterPayment) : 0,
        'isCanSave' : maximumParkingFeePerDayActive === 'DISABLE' ? true : false, 
      }));
    }
  }

    handleEvent = (key, value) => {      
      this.setState({ [key]: value }, () => {this.handleIsCanSave();});
    }

    render() {
      const {
        maximumParkingFeePerDayActive,
        maximumParkingFeePerDay,
        exitPeriodAfterPayment,        
      } = this.state;

      return (
        <div className="ConfigCommon">
          <Card>
            <HeaderSection title="Config common" isHeader={true} />
            <div className="config-common-container">
              <div className="config-common-first-row">
                <div className="maximum-parking-fee-per-day-status-container">
                  <div className="maximum-parking-fee-per-day-status-label">Maximum parking fee per day</div>
                  <div className="status-button-container">
                    <div className={`status-button ${maximumParkingFeePerDayActive === 'ENABLE' ? 'active' : ''}`} onClick={() => this.handleEvent('maximumParkingFeePerDayActive', 'ENABLE')}>Enable</div>
                    <div className={`status-button ${maximumParkingFeePerDayActive === 'DISABLE' ? 'active' : ''}`} onClick={() => this.handleEvent('maximumParkingFeePerDayActive', 'DISABLE')}>Disable</div>
                  </div>

                </div>
                <div className="maximum-parking-fee-per-day-input-container">
                  <div className="maximum-parking-fee-per-day-input-label">
                    <Tooltip tooltip="กำหนดอัตราค่าบริการจอดรถสูงสุดต่อวันไม่เกิน (บาท)">
                      <span>Maximum parking fee per day</span>
                    </Tooltip>
                  </div>
                  <div className="maximum-parking-fee-per-day-input">
                    <Input
                      id="maximum-parking-fee-per-day-input"
                      className={'template-d'}
                      placeholder="Input maximum parking fee per day"
                      value={maximumParkingFeePerDay}
                      onChange={(event) => {
                        const value = event.target.value;
                        if (validateNumber(value)) {
                          this.handleEvent('maximumParkingFeePerDay', value);
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="exit-after-period-input-container">
                <div className="exit-after-period-input-label">
                  <Tooltip tooltip="กำหนดเวลาเพื่ออนุญาตให้รถออกได้หลังชำระค่าบริการแม้จะเกินเวลาจอด xx นาท">
                    <span>Allow visitor/member exit after paid fee</span>
                  </Tooltip>
                </div>
                <div className="exit-after-period-input">
                  <Input
                    id="exit-after-period-input"
                    className={'template-d'}
                    placeholder="Input period time in minutes ex. 15, 20"
                    value={exitPeriodAfterPayment}
                    onChange={(event) => {
                      const value = event.target.value;
                      if (validateNumber(value)) {
                        this.handleEvent('exitPeriodAfterPayment', value);
                      }
                    }}
                  />
                </div>
              </div>
            </div>
         
          </Card>
        </div>
      );
    }
}

ConfigCommon.propTypes = {
  'buildingInformation': PropTypes.shape({
    'data': PropTypes.any,
  }),
};

const mapStateToProps = ({ configCommon }) => ({
  'configCommon': configCommon.data,
});

export default connect(mapStateToProps)(ConfigCommon);

ConfigCommon.propTypes = {
  'dispatch' : PropTypes.func,
  'configCommon' : PropTypes.shape({
    'maximumParkingFeePerDayActive' : PropTypes.string,
    'maximumParkingFeePerDay' : PropTypes.number,
    'exitPeriodAfterPayment' : PropTypes.number,
  }),
};
